// libs
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// actions
import actions from '../../../actions/modal';

// styles
import './styles.scss';

const propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
  ]),
  hideModal: PropTypes.func.isRequired,
  modalContentDefaultProps: PropTypes.object,
};

const defaultProps = {
  component: null,
  modalContentDefaultProps: {},
};

class ModalContent extends Component {
  static propTypes = propTypes;
  static defaultProps = defaultProps;
  componentWillUnmount() {
    document.getElementsByTagName('html')[0].style.overflowY = '';
  }

  render() {
    const {
      component: ComponentName,
      hideModal,
      modalContentDefaultProps,
    } = this.props;
    return (
      <div className="modal__content">
        <button className="modal__close" onClick={() => hideModal()} />
        {ComponentName && <ComponentName {...modalContentDefaultProps} />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    component: state.modal.component,
    modalContentDefaultProps: state.modal.defaultProps,
  };
}

export default connect(mapStateToProps, actions)(ModalContent);



// WEBPACK FOOTER //
// ./src/app/components/layouts/modal/ModalContent.js